import React from 'react';

export default class CombinationSection extends React.Component {
  getAddedComponentsList = () => {
    const {allComponents, system} = this.props;
    const resultComponents = [];

    if (system.ruleValueRequests && system.ruleValueRequests.length) {
      system.ruleValueRequests.forEach(rule => {
        if (rule.componentIdWithQuantityMap) {
          Object.keys(rule.componentIdWithQuantityMap)
            .forEach(key => {
              const component = allComponents[key];
              if (component) {
                component.quantity = rule.componentIdWithQuantityMap[key];
              }
              resultComponents.push(component);
            });
        }
      });
    }

    return resultComponents.filter(component => component);
  };

  __isVisible = () => {
    return this.props.isActive ? '' : '__invisible'
  };

  render() {
    const {system, allComponents} = this.props;

    if (!system) return null;
    if (!Object.keys(allComponents).length) return null;

    const components = this.getAddedComponentsList();

    if (!components.length) return null;

    return (
      <section className={`boat-systems-details-section__components-list ${this.__isVisible()}`}>
        <div className='boat-systems-details-section__components-list-header'>
          <div className='boat-systems-details-section__components-list-item _width_pc_30'>Manufacturer Name</div>

          <div className='boat-systems-details-section__components-list-item _width_pc_10 _margin_left_20'>ID</div>

          <div className='boat-systems-details-section__components-list-item _width_pc_15 _margin_left_20'>Type</div>

          <div className='boat-systems-details-section__components-list-item _width_pc_30 _margin_left_20'>
            Description
          </div>

          <div className='boat-systems-details-section__components-list-item _width_pc_10 _text_align_center'>Qty</div>
        </div>
        {components.map((component, index) => {
          return (
            <div key={component.id + index} className='boat-systems-details-section__components-list-row'>
              <div className='boat-systems-details-section__components-list-item _width_pc_30'>
                {component.manufacturerName}
              </div>

              <div className='boat-systems-details-section__components-list-item _width_pc_10 _margin_left_20'>
                {component.id}
              </div>

              <div className='boat-systems-details-section__components-list-item _width_pc_15 _margin_left_20'>
                {component.componentType.componentTypeName}
              </div>

              <div className='boat-systems-details-section__components-list-item _width_pc_30 _margin_left_20'>
                {component.description}
              </div>

              <div className='boat-systems-details-section__components-list-item _width_pc_10 _text_align_center'>
                {component.quantity}
              </div>
            </div>
          );
        })}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatSystems/CombinationSection.jsx